export default __webpack_public_path__ + "static/media/washerdryers.0350ba42.png";